// extracted by mini-css-extract-plugin
export default {"addToCartControl":"WZ-z","giftCard":"XZ-z","btnContainer":"YZ-z","cartButton":"ZZ-z","disabled":"_Z-z"};